/**
 * Defines a division's profile, which is used to configure and default options in OTB
 */
import { WeightClassGroup } from '@reg/shared/model/weight-class-group.model';

export class DivisionProfile {
    public static FOLKSTYLE_ID: string = 'DA7A24D4-D9DB-4E21-B71A-A58280AF3858';
    public static COLLEGE_ID: string = 'DDF2EC43-FDC4-4213-A61F-F991ADDD025D';

    public id: string;
    public name: string;
    public floLevelId: string;
    public weightClassGroups: WeightClassGroup[] = null;

    constructor(id: string = null) {
        this.id = id;
    }

    public clone(): DivisionProfile {
        const clone: DivisionProfile = new DivisionProfile();
        clone.id = this.id;
        clone.name = this.name;

        if (this.weightClassGroups) {
            clone.weightClassGroups = this.weightClassGroups.map((w: WeightClassGroup) => w.clone());
        }

        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        return JSON.stringify(this);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object, included: any[]): DivisionProfile {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'] || [];
        const relationships: Object = data['relationships'] || [];

        this.id = json['id'];
        this.name = attrs['name'];
        this.floLevelId = attrs['floLevelId'];

        const weightClassGroupLinks: Object[] = relationships['weightClassGroups'];
        if (weightClassGroupLinks &&
            included &&
            weightClassGroupLinks['data']) {
            this.weightClassGroups = [];

            for (const weightClassGroupLink of weightClassGroupLinks['data']) {
                const weightClassGroupInclude: Object =
                    included.filter((i: Object) => i['id'] === weightClassGroupLink['id'])[0];

                if (weightClassGroupInclude) {
                    const weightClassGroup: WeightClassGroup =
                        (new WeightClassGroup()).deserialize(weightClassGroupInclude, included);
                    this.weightClassGroups.push(weightClassGroup);
                }
            }
        }

        return this;
    }
}
